var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.items),function(item,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.goAction(item.action)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_c('v-list-item-title',[_vm._v(_vm._s(item.title))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }